import { Button } from 'antd';
import styled from 'styled-components';

export const BoldText = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const ScrollableList = styled.ul`
  max-height: 400px;
  overflow-y: auto;
  margin: 8px 0;
  padding-left: 24px;
`;

export const SeeMoreButton = styled(Button)`
  color: ${({ theme }) => theme.colors.link} !important;
  align-self: flex-start;
`;
